// extracted by mini-css-extract-plugin
export default {"container":"Resume_container__z5SQi"};